<template>
    <div>
        <el-alert type="warning" :closable="false" class="mb-3">
            <div slot="title" style="font-size:14px;">
                <i class="el-icon-info"></i> 仅当会议中主持人开启了"实时转写"功能，会后才会生成转写记录。如未开启，此处将无数据。
            </div>
        </el-alert>

        <el-alert :type="alertType" :closable="false" class="mb-3">
            <div slot="title">
                <div style="font-size:14px;" v-if="loading">
                    <i class="el-icon-loading"></i> 正在查询会议转写记录...
                </div>
                <div style="font-size:14px;" v-else-if="downloadUrls.length > 0">
                    该会议有实时转写记录，请点击下载。
                    <span class="text-warning">下载链接有效期为2小时，过期请点击重新查询。</span>
                </div>
                <div style="font-size:14px;" v-else>
                    {{ errorMsg || '该会议没有实时转写记录。' }}
                </div>
            </div>
        </el-alert>

        <div v-if="downloadUrls.length > 0">
            <el-button type="primary" icon="el-icon-download"
                       v-for="(url, index) in downloadUrls" :key="index"
                       class="mr-3" @click="handleDownload(url)">
                下载转写文件 (Word)
            </el-button>
            <el-button type="text" @click="queryTranscription" :loading="loading" class="ml-3">
                <i class="el-icon-refresh"></i> 重新查询
            </el-button>
        </div>

        <div v-if="!loading && downloadUrls.length === 0 && queried" class="text-center text-muted mt-3">
            <p>如果确认会议已开启实时转写功能，请稍后再试。</p>
            <el-button type="primary" plain size="small" @click="queryTranscription" :loading="loading">
                <i class="el-icon-refresh"></i> 重新查询
            </el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'meeting-view-transcription-info',
    data() {
        return {
            loading: false,
            downloadUrls: [],
            errorMsg: '',
            queried: false,
        }
    },
    props: {
        single: {
            type: Object,
            default() {
                return {};
            }
        },
        active: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        alertType() {
            if (this.loading) return 'info';
            if (this.downloadUrls.length > 0) return 'success';
            if (this.errorMsg) return 'warning';
            return 'info';
        },
    },
    watch: {
        active: {
            immediate: true,
            handler(val) {
                if (val && !this.queried) {
                    this.queryTranscription();
                }
            }
        }
    },
    methods: {
        queryTranscription() {
            if (!this.single.id) return;
            this.loading = true;
            this.errorMsg = '';
            this.$api('Report.Meeting.Detail.Transcription', {
                id: this.single.id,
                file_type: 1
            }, true).then(res => {
                const data = res.data.data;
                this.downloadUrls = data.download_url || [];
                this.queried = true;
            }).catch(err => {
                this.downloadUrls = [];
                this.queried = true;
                const msg = err.response && err.response.data && err.response.data.message;
                this.errorMsg = msg || '查询失败，请稍后再试。';
            }).finally(() => {
                this.loading = false;
            });
        },
        handleDownload(url) {
            window.open(url, '_blank');
        }
    }
}
</script>
